import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { CAMPAIGN_TYPES } from 'shared/constants/campaign';

export const useCampaign = (selectedInbox = null) => {
  const route = useRoute();
  const store = useStore();
  const { t } = useI18n();

  const campaignType = computed(() => {
    const pageURL = route.fullPath;
    return pageURL.substring(pageURL.lastIndexOf('/') + 1);
  });

  const campaignTypeAsUrlMember = computed(() => {
    const pageURL = route.fullPath;
    return pageURL.split('/').reverse()[1];
  });

  const isOngoingType = computed(() => {
    return (
      campaignType.value === CAMPAIGN_TYPES.ONGOING ||
      campaignTypeAsUrlMember.value === CAMPAIGN_TYPES.ONGOING
    );
  });

  const isOneOffType = computed(() => {
    return (
      campaignType.value === CAMPAIGN_TYPES.ONE_OFF ||
      campaignTypeAsUrlMember.value === CAMPAIGN_TYPES.ONE_OFF
    );
  });

  const campaignDisplayId = computed(() => {
    const pageURL = route.fullPath;
    if (route?.params?.campaignDisplayId) return route.params.campaignDisplayId;
    return pageURL.substring(pageURL.lastIndexOf('/') + 1);
  });

  const campaignId = computed(() => {
    const pageURL = route.fullPath;
    if (route?.params?.campaignId) return route.params.campaignId;
    return pageURL.substring(pageURL.lastIndexOf('/') + 1);
  });

  const isCommonWhatsappCampaign = computed(() => {
    if (!selectedInbox?.value) return false;
    return selectedInbox.value.channel_type === 'Channel::CommonWhatsapp';
  });

  const isWhatsappCampaign = computed(() => {
    if (!selectedInbox?.value) return false;
    return selectedInbox.value.channel_type === 'Channel::Whatsapp';
  });

  const statusSettings = computed(() => ({
    // ONE OFF CAMPAIGN STATUS
    active: {
      icon: 'arrow-right',
      text: t('CAMPAIGN.REPORT.DETAILS.STATUS.ACTIVE'),
      colorScheme: 'primary',
    },
    processing: {
      icon: 'arrow-right',
      text: t('CAMPAIGN.REPORT.DETAILS.STATUS.PROCESSING'),
      colorScheme: 'success',
    },
    in_progress: {
      icon: 'arrow-up',
      text: t('CAMPAIGN.REPORT.DETAILS.STATUS.IN_PROGRESS'),
      colorScheme: 'secondary',
    },
    completed: {
      icon: 'checkmark',
      text: t('CAMPAIGN.REPORT.DETAILS.STATUS.COMPLETED'),
      colorScheme: 'success',
    },
    error: {
      icon: 'warning',
      text: t('CAMPAIGN.REPORT.DETAILS.STATUS.ERROR'),
      colorScheme: 'alert',
    },
    aborted: {
      icon: 'warning',
      text: t('CAMPAIGN.REPORT.DETAILS.STATUS.ABORTED'),
      colorScheme: 'alert',
    },
    // ONGOING CAMPAIGN STATUS
    enabled: {
      icon: 'arrow-right',
      text: t('CAMPAIGN.ONGOING.STATUS.ENABLED'),
      colorScheme: 'primary',
    },
    disabled: {
      icon: 'warning',
      text: t('CAMPAIGN.ONGOING.STATUS.DISABLED'),
      colorScheme: 'alert',
    },
  }));

  const campaignInboxes = computed(() => {
    return store.getters['inboxes/getInboxes'].filter(
      inbox =>
        (inbox.channel_type === 'Channel::Whatsapp' &&
          inbox.provider === 'whatsapp_cloud') ||
        inbox.channel_type === 'Channel::CommonWhatsapp'
    );
  });

  const campaignStatusInfos = campaignStatus => {
    return statusSettings.value[campaignStatus];
  };

  return {
    // Computed properties
    campaignType,
    campaignTypeAsUrlMember,
    isOngoingType,
    isOneOffType,
    campaignDisplayId,
    campaignId,
    isCommonWhatsappCampaign,
    isWhatsappCampaign,
    statusSettings,
    campaignInboxes,

    // Methods
    campaignStatusInfos,
  };
};
